import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import request from '@/utils/request'
import auth from '@/utils/auth'

import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css'
import '@/assets/common.css'    // 使用 CSS

import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)

import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

Vue.config.productionTip = false
Vue.use(ViewUI)

// Vant
import Vant from 'vant'
import 'vant/lib/index.css'
Vue.use(Vant)
import { Lazyload } from 'vant'
Vue.use(Lazyload)

const authH5 = async () => {
  if (store.state.token) {
    const refreshed = await auth.refreshToken()
    if (refreshed) {return}
  }
  await auth.wxAuthorize()
}

const initData = async () => {
  // 初始化区域列表
  await request.get('/api/sys/area/children/430527').then((res) => store.commit('setAreaList', res))
  // 若区域ID为空，还需查询定制信息初始化定制的区域ID
  if (!store.state.areaId) {
    await request.get('/api/farming/rest_msg_set/info').then((res) => store.commit('setAreaId', res.areaId))
  }
  // 初始化当前用户信息
  await request.get('/api/account/rest_account').then((res) => store.commit('setCurrent', res))
  // 若已关联管理人员（专家、种植户或合作社），还需初始管理人员信息
  const { role } = store.state.current
  if (role && role >= 1 && role <= 2) {await request.get(`/api/farming/rest_rel/${role}`).then((res) => store.commit('setManagerInfo', res))}
}

const init = async () => {
  await authH5()
  await initData()
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}
init()
